import Permissions from '@app/src/auth/permissions'
import navbarLinks from '@app/src/wf-constants/navigationLinks'
import { useFlags } from 'launchdarkly-react-client-sdk'
import React from 'react'
import { useIntl } from 'react-intl'
import { MenuLinkWrapper, type MenuLinkWrapperProps } from './MenuWrapper'
import type { NavigationItemProps } from './NavigationItems'

const RecommendedJourneyLink: React.FC<NavigationItemProps> = ({ icon }) => {
  const { formatMessage } = useIntl()
  const { recommendedActions } = useFlags()

  if (!recommendedActions) return null

  const menuItems: MenuLinkWrapperProps['menuItems'] = {
    link: navbarLinks.recommendedJourney,
    permission: [Permissions.SOURCING_USER, Permissions.FINANCE_USER, Permissions.INVESTMENT_USER],
  }

  return (
    <MenuLinkWrapper menuItems={menuItems} title={formatMessage({ id: 'navbar.recommendedJourney' })} icon={icon} />
  )
}

export default RecommendedJourneyLink
